import { collection, getDocs, orderBy, query, where } from 'firebase/firestore';
import { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from './firebase.js';
import { Window } from './obj.js';

export default function Blog() {
	const [entries, setEntries] = useState([]);
	const bonusEntries = useMemo(
		() => entries.filter(e => isNaN(e.data.week)),
		[entries],
	);
	const sem1Entries = useMemo(
		() =>
			entries.filter(
				e => !isNaN(e.data.week) && e.data.date.toDate().getMonth() < 6,
			), // month is 0-indexed
		[entries],
	);
	const sem2Entries = useMemo(
		() =>
			entries.filter(
				e => !isNaN(e.data.week) && e.data.date.toDate().getMonth() >= 6,
			), // month is 0-indexed
		[entries],
	);
	const currentYear = new Date().getFullYear();
	const earliestAvailableYear = 2024;
	const yearOptions = [];
	for (let year = currentYear; year >= earliestAvailableYear; year--) {
		yearOptions.push(year);
	}
	const [selectedYear, setSelectedYear] = useState(currentYear);

	useEffect(() => {
		let mounted = true;
		async function loadBlogs() {
			// Get blog data
			const q = query(
				collection(db, 'blogs'),
				where('date', '>=', new Date(`${selectedYear}-01-01`)),
				where('date', '<=', new Date(`${selectedYear}-12-31`)),
				orderBy('date'),
			);
			const querySnapshot = await getDocs(q);
			if (!mounted) return;
			const items = querySnapshot.docs.map(snap => ({
				id: snap.id,
				data: snap.data(),
			}));
			console.log(items);
			setEntries(items);
		}
		loadBlogs();
		return () => {
			mounted = false;
		};
	}, [selectedYear]);

	if (entries === null) return <>Loading...</>;
	return (
		<>
			<main>
				<section className="centercol">
					<select
						name="year"
						id="year"
						value={selectedYear}
						onChange={e => setSelectedYear(e.target.value)}
						style={{
							minWidth: '20%',
							marginTop: '5px',
							textAlign: 'center',
							fontWeight: 'bold',
							fontFamily: "'Space Mono', monospace",
							color: 'var(--dark-bg)',
							borderColor: 'var(--dark-bg)',
							border: '2px solid',
						}}
					>
						{yearOptions.map(year => (
							<option value={`${year}`}>{year}</option>
						))}
					</select>
					<div className="problemWindow" style={{minWidth: '40%'}}>
						<Window title="Semester 1">
							<ul>
								{sem1Entries.map(e => (
									<li key={e.id}>
										<Link to={`${e.id}`}>
											W{e.data.week} - {e.data.topic}
										</Link>
									</li>
								))}
							</ul>
						</Window>
					</div>
					{sem2Entries.length > 0 && (
						<div className="problemWindow" style={{minWidth: '40%'}}>
							<Window title="Semester 2">
								<ul>
									{sem2Entries.map(e => (
										<li key={e.id}>
											<Link to={`${e.id}`}>
												W{e.data.week} - {e.data.topic}
											</Link>
										</li>
									))}
								</ul>
							</Window>
						</div>
					)}
					{bonusEntries.length > 0 && (
						<div className="problemWindow" style={{minWidth: '40%'}}>
							<Window title="Bonus">
								<ul>
									{bonusEntries.map(e => (
										<li key={e.id}>
											<Link to={`${e.id}`}>{e.data.topic}</Link>
										</li>
									))}
								</ul>
							</Window>
						</div>
					)}
				</section>
			</main>
		</>
	);
}
